import React, { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import { wareHouseService } from '../../services/warehouse.service';
import { useNavigate } from 'react-router-dom';
import LogicContext from '../../Context/LogicContext';
import { GetWareHouseEdit, ResetWareHouseEdit } from "../../store/warehouseAtom";




const WareHouseAddNewPage = () => {
      const myPromiseModal = createModal(GeneralModal);
        const navigate = useNavigate();
        const editableData =  GetWareHouseEdit();
        const resetEdit  =  ResetWareHouseEdit();
        const { showToast, httpResponseManager } = useContext(LogicContext);
    
  const { 
    register, 
    handleSubmit, 
    formState: { errors, isSubmitting, isValid },
    reset,
    setValue,
    watch
  } = useForm({
    mode: 'onChange', // Validate on change for better UX
    defaultValues: {
      warehouse_name: "",
      warehouse_contact_person: "",
      warehouse_contact_number: "",
      warehouse_email_address: "",
      warehouse_latitude: "",
      warehouse_longitude: "",
      warehouse_address: ""
    }
  });

  useEffect(()=> {
    if(editableData?.warehouse_id){
      setValue('warehouse_id', editableData.warehouse_id);
      setValue('warehouse_name', editableData.warehouse_name);
      setValue('warehouse_contact_person', editableData.warehouse_contact_person);
      setValue('warehouse_contact_number', editableData.warehouse_contact_number);
      setValue('warehouse_email_address', editableData.warehouse_email_address);
      setValue('warehouse_address', editableData.warehouse_address);
      setValue('warehouse_latitude', editableData.warehouse_latitude);
      setValue('warehouse_longitude', editableData.warehouse_longitude);

    }

    return ()=> {
      resetEdit();
    }

  },[editableData]);

  const onSubmit = async (data) => {
    // Simulate API call
    let option = '1';

    const confirm = await myPromiseModal({
        title: `${editableData?.warehouse_id ? "Update Warehouse information": "Save Warehouse information"}`,
        body: 'Please confirm your action?',
        showInput: false,
      });
      if(editableData?.warehouse_id){
        option = '2';
      }
      
  
      if (!confirm?.decision) return;
    
         try {
            const res = await wareHouseService.submitWareHouse({...data, option: option});
            const response = httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
      
            if (response.message_id === 1) {
              showToast(response.message_text || 'Stock opening saved successfully!', 'success');
              sessionStorage.setItem('reloadPage', 'true');
              navigate(-1);

            } else {
              showToast(response.message_text || 'Failed to save', 'error');
            }
          } catch (err) {
            showToast('Error submitting form', 'error');
          }
    
    // Reset form after submission
  };

  // Watch latitude and longitude for validation preview
  const latitude = watch("warehouse_latitude");
  const longitude = watch("warehouse_longitude");

  // Format coordinates for display
  const formatCoordinate = (coord) => {
    if (!coord || coord === "") return "Not provided";
    const num = parseFloat(coord);
    return isNaN(num) ? "Invalid" : num.toFixed(6);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Create New Warehouse
          </h1>
          <p className="text-gray-600">
            Fill in the details below to register a new warehouse facility
          </p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <form onSubmit={handleSubmit(onSubmit)} className="p-6 sm:p-8">
            {/* Warehouse Information Section */}
            <div className="mb-10 pb-8 border-b border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-gray-800">
                  Warehouse Information
                </h2>
              </div>

              {/* Warehouse Name */}
              <div className="mb-6">
                <label htmlFor="warehouse_name" className="block text-sm font-medium text-gray-700 mb-2">
                  Warehouse Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    id="warehouse_name"
                    type="text"
                    placeholder="Enter warehouse name"
                    className={`
                      w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                      transition duration-200 ease-in-out
                      ${errors.warehouse_name 
                        ? 'border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400' 
                        : 'border-gray-300 bg-gray-50 focus:bg-white'
                      }
                    `}
                    {...register("warehouse_name", { 
                      required: "Warehouse name is required",
                      minLength: {
                        value: 3,
                        message: "Warehouse name must be at least 3 characters"
                      },
                      maxLength: {
                        value: 100,
                        message: "Warehouse name must not exceed 100 characters"
                      }
                    })}
                  />
                  {errors.warehouse_name && (
                    <div className="absolute right-3 top-3">
                      <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                {errors.warehouse_name && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v4a1 1 0 102 0V5zm-1 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                    </svg>
                    {errors.warehouse_name.message}
                  </p>
                )}
              </div>

              {/* Contact Person */}
              <div className="mb-6">
                <label htmlFor="warehouse_contact_person" className="block text-sm font-medium text-gray-700 mb-2">
                  Contact Person <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    id="warehouse_contact_person"
                    type="text"
                    placeholder="Enter contact person's full name"
                    className={`
                      w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                      transition duration-200 ease-in-out
                      ${errors.warehouse_contact_person 
                        ? 'border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400' 
                        : 'border-gray-300 bg-gray-50 focus:bg-white'
                      }
                    `}
                    {...register("warehouse_contact_person", { 
                      required: "Contact person is required",
                      minLength: {
                        value: 2,
                        message: "Contact person name must be at least 2 characters"
                      },
                      maxLength: {
                        value: 100,
                        message: "Contact person name must not exceed 100 characters"
                      }
                    })}
                  />
                  {errors.warehouse_contact_person && (
                    <div className="absolute right-3 top-3">
                      <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                {errors.warehouse_contact_person && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v4a1 1 0 102 0V5zm-1 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                    </svg>
                    {errors.warehouse_contact_person.message}
                  </p>
                )}
              </div>

              {/* Contact Number */}
              <div className="mb-6">
                <label htmlFor="warehouse_contact_number" className="block text-sm font-medium text-gray-700 mb-2">
                  Contact Number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">+</span>
                  </div>
                  <input
                    id="warehouse_contact_number"
                    type="tel"
                    placeholder="1234567890"
                    className={`
                      w-full pl-8 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                      transition duration-200 ease-in-out
                      ${errors.warehouse_contact_number 
                        ? 'border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400' 
                        : 'border-gray-300 bg-gray-50 focus:bg-white'
                      }
                    `}
                    {...register("warehouse_contact_number", { 
                      required: "Contact number is required",
                      pattern: {
                        value: /^[\+]?[1-9][\d]{7,14}$/,
                        message: "Please enter a valid phone number (8-15 digits)"
                      }
                    })}
                  />
                  {errors.warehouse_contact_number && (
                    <div className="absolute right-3 top-3">
                      <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                {errors.warehouse_contact_number && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v4a1 1 0 102 0V5zm-1 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                    </svg>
                    {errors.warehouse_contact_number.message}
                  </p>
                )}
              </div>

              {/* Email Address */}
              <div className="mb-6">
                <label htmlFor="warehouse_email_address" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <input
                    id="warehouse_email_address"
                    type="email"
                    placeholder="contact@example.com"
                    className={`
                      w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                      transition duration-200 ease-in-out
                      ${errors.warehouse_email_address 
                        ? 'border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400' 
                        : 'border-gray-300 bg-gray-50 focus:bg-white'
                      }
                    `}
                    {...register("warehouse_email_address", { 
                      required: "Email address is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address"
                      }
                    })}
                  />
                  {errors.warehouse_email_address && (
                    <div className="absolute right-3 top-3">
                      <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                {errors.warehouse_email_address && (
                  <p className="mt-2 text-sm text-red-600 flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v4a1 1 0 102 0V5zm-1 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                    </svg>
                    {errors.warehouse_email_address.message}
                  </p>
                )}
              </div>


              <div style={{ marginBottom: '15px' }}>
                    <label htmlFor="warehouse_address">Warehouse Address</label>
                    <input
                        id="warehouse_address"
                        type="text"
                        {...register('warehouse_address', { required: 'Warehouse address is required' })}
                        style={{ width: '100%', padding: '8px' }}
                    />
                    {errors.warehouse_address && <span style={{ color: 'red' }}>{errors.warehouse_address.message}</span>}
                    </div>
            </div>

            {/* Location Coordinates Section */}
            <div className="mb-10 pb-8 border-b border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-gray-800">
                  Location Coordinates
                </h2>
              </div>

              <p className="text-gray-600 text-sm mb-6">
                Enter the geographic coordinates for precise warehouse location.
                Latitude should be between -90 and 90, Longitude between -180 and 180.
              </p>

              {/* Coordinates Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {/* Latitude */}
                <div>
                  <label htmlFor="warehouse_latitude" className="block text-sm font-medium text-gray-700 mb-2">
                    Latitude <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      id="warehouse_latitude"
                      type="number"
                      step="any"
                      placeholder="e.g., 40.7128"
                      className={`
                        w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                        transition duration-200 ease-in-out
                        ${errors.warehouse_latitude 
                          ? 'border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400' 
                          : 'border-gray-300 bg-gray-50 focus:bg-white'
                        }
                      `}
                      {...register("warehouse_latitude", { 
                        min: {
                          value: -90,
                          message: "Latitude must be at least -90"
                        },
                        max: {
                          value: 90,
                          message: "Latitude must be at most 90"
                        },
                        valueAsNumber: true
                      })}
                    />
                    {errors.warehouse_latitude && (
                      <div className="absolute right-3 top-3">
                        <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </div>
                    )}
                  </div>
                  {errors.warehouse_latitude && (
                    <p className="mt-2 text-sm text-red-600 flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v4a1 1 0 102 0V5zm-1 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                      </svg>
                      {errors.warehouse_latitude.message}
                    </p>
                  )}
                </div>

                {/* Longitude */}
                <div>
                  <label htmlFor="warehouse_longitude" className="block text-sm font-medium text-gray-700 mb-2">
                    Longitude <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      id="warehouse_longitude"
                      type="number"
                      step="any"
                      placeholder="e.g., -74.0060"
                      className={`
                        w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                        transition duration-200 ease-in-out
                        ${errors.warehouse_longitude 
                          ? 'border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400' 
                          : 'border-gray-300 bg-gray-50 focus:bg-white'
                        }
                      `}
                      {...register("warehouse_longitude", { 
                        min: {
                          value: -180,
                          message: "Longitude must be at least -180"
                        },
                        max: {
                          value: 180,
                          message: "Longitude must be at most 180"
                        },
                        valueAsNumber: true
                      })}
                    />
                    {errors.warehouse_longitude && (
                      <div className="absolute right-3 top-3">
                        <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </div>
                    )}
                  </div>
                  {errors.warehouse_longitude && (
                    <p className="mt-2 text-sm text-red-600 flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v4a1 1 0 102 0V5zm-1 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                      </svg>
                      {errors.warehouse_longitude.message}
                    </p>
                  )}
                </div>
              </div>

              {/* Coordinates Preview */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-5 border border-blue-100">
                <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <svg className="w-4 h-4 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"></path>
                  </svg>
                  Coordinates Preview
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-3 border border-blue-200">
                    <p className="text-xs text-gray-500 mb-1">Latitude</p>
                    <p className="font-mono text-sm font-medium text-gray-800">
                      {formatCoordinate(latitude)}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-3 border border-blue-200">
                    <p className="text-xs text-gray-500 mb-1">Longitude</p>
                    <p className="font-mono text-sm font-medium text-gray-800">
                      {formatCoordinate(longitude)}
                    </p>
                  </div>
                </div>
                {latitude && longitude && !errors.warehouse_latitude && !errors.warehouse_longitude && (
                  <div className="mt-4 flex items-center text-green-600 text-sm">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Valid coordinates entered
                  </div>
                )}
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
              <div className="text-sm text-gray-500">
                <span className="text-red-500">*</span> indicates a required field
              </div>
              <div className="flex justify-end gap-4 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition flex items-center gap-2"
            >
              Save
              {/* {stockEdit?.opening_main?.[0]?.ref_no ? "Update Stock":"Save Stock"} */}
            </button>
          </div>
             
            </div>
          </form>
        </div>

        {/* Form Status */}
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>All form fields are validated in real-time. Submit button will be enabled when all validations pass.</p>
        </div>
      </div>
    </div>
  );
};

export default WareHouseAddNewPage;